/** Admin messages: the emails the Vault Play admin team sent this Shop from Admin › Email shops. */
export const ADMIN_MESSAGES_PATH = '/admin-messages';
export const ADMIN_MESSAGES_LABEL = 'Admin messages';

/** Fired after the Shop opens a message, so the sidebar count refreshes at once. */
export const ADMIN_MESSAGES_CHANGED_EVENT = 'admin-messages-changed';

export function adminMessagePath(id: string): string {
  return `${ADMIN_MESSAGES_PATH}/${encodeURIComponent(id)}`;
}

export function announceAdminMessagesChange(): void {
  window.dispatchEvent(new Event(ADMIN_MESSAGES_CHANGED_EVENT));
}
